import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GlobalUtils } from "../../../utils";
import APPROVE from "../../../assets/Approved.svg";
import ACCEPTED from "../../../assets/Accepted.svg";
import ESIGNED from "../../../assets/eSigned.svg";
import PAID from "../../../assets/Paid.svg";

const { readDataFromLocalStorage } = GlobalUtils;
class DocumentStatusBand extends Component {
  state = {};

  render() {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    const { stage, docRecipientList, acceptorsList } = this.props;
    const signerList = [];
    docRecipientList.map(item =>
      item.recipient_type === "SIGNER" ? signerList.push(item) : null,
    );
    let bandStatus = null;
    if (
      CURRENT_USER &&
      this.props.mode === "DOCUMENT" &&
      !this.props.isSharedDocument
    ) {
      if (this.props.paymentStatus === "Paid") {
        bandStatus = (
          <div className="doc-status-band remove-from-export">
            <img src={PAID} className="doc-imgband-check-wrapper" alt="Revv" />
            <div>You have received payment in this document</div>
          </div>
        );
      } else if (stage === "INTERNAL_REVIEW") {
        if (this.props.pendingApprovalRequired) {
          bandStatus = (
            <div className="doc-status-band remove-from-export">
              <span className="doc-status-internal-check">
                <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
              </span>

              <div> Your approval is required on this document</div>
            </div>
          );
        } else if (
          this.props.docApprovalStatus[0] &&
          this.props.docApprovalStatus[0].workflowStatus === "REJECTED"
        ) {
          bandStatus = (
            <div className="doc-declined-status-band remove-from-export">
              <span className="doc-statusband-check-wrapper">
                <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
              </span>

              <div>Approval request on document rejected</div>
            </div>
          );
        } else if (
          this.props.docApprovalStatus[0] &&
          this.props.docApprovalStatus[0].workflowStatus === "PENDING"
        ) {
          bandStatus = (
            <div className="doc-status-warning-band remove-from-export">
              <span className="doc-statusband-check-wrapper">
                <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
              </span>

              <div>Document sent for internal approval</div>
            </div>
          );
        }
      } else if (stage === "APPROVED") {
        if (
          this.props.docApprovalStatus &&
          this.props.docApprovalStatus.length > 0
        ) {
          bandStatus = (
            <div className="doc-status-band remove-from-export">
              <img
                src={APPROVE}
                className="doc-imgband-check-wrapper"
                alt="Revv"
              />

              <div>Everyone approved the document</div>
            </div>
          );
        } else {
          bandStatus = (
            <div className="doc-status-band remove-from-export">
              <img
                src={APPROVE}
                className="doc-imgband-check-wrapper"
                alt="Revv"
              />

              <div>
                Document did not trigger any workflow. It is auto-approved
              </div>
            </div>
          );
        }
      } else if (stage === "SENT") {
        if (acceptorsList && acceptorsList.length > 0) {
          if (
            acceptorsList &&
            acceptorsList.find(
              item =>
                item.user &&
                item.user.id === CURRENT_USER.id &&
                item.recipient_type === "ACCEPTOR" &&
                item.accepting_states === "",
            )
          ) {
            bandStatus = (
              <div className="doc-status-warning-band remove-from-export">
                <span className="doc-statusband-check-wrapper">
                  <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
                </span>

                <div>Your consent is required on this document</div>
              </div>
            );
          } else {
            bandStatus = (
              <div className="doc-status-warning-band remove-from-export">
                <span className="doc-statusband-check-wrapper">
                  <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
                </span>

                <div>Document sent for acceptance</div>
              </div>
            );
          }
        } else if (signerList && signerList.length > 0) {
          if (
            docRecipientList &&
            docRecipientList.find(
              item =>
                item.user &&
                item.user.id === CURRENT_USER.id &&
                item.recipient_type === "SIGNER",
            )
          ) {
            bandStatus = (
              <div className="doc-status-warning-band remove-from-export">
                <span className="doc-statusband-check-wrapper">
                  <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
                </span>

                <div>Document requires your consent.</div>
              </div>
            );
          } else {
            bandStatus = (
              <div className="doc-status-warning-band remove-from-export">
                <span className="doc-statusband-check-wrapper">
                  <FontAwesomeIcon icon={["far", "signature"]} />
                </span>
                <div>Document sent for eSignature</div>
              </div>
            );
          }
        }
      } else if (stage === "COMPLETED") {
        if (acceptorsList && acceptorsList.length > 0) {
          bandStatus = (
            <div className="doc-status-band remove-from-export">
              <img
                src={ACCEPTED}
                className="doc-imgband-check-wrapper"
                alt="Revv"
              />
              <div>Everyone accepted the document</div>
            </div>
          );
        } else if (signerList && signerList.length > 0) {
          bandStatus = (
            <div className="doc-esigncompleted-status-band remove-from-export">
              <img
                src={ESIGNED}
                className="doc-esign-imgband-check"
                alt="Revv"
              />

              <div>Everyone signed the document</div>
            </div>
          );
        }
      } else if (stage === "DECLINED") {
        if (acceptorsList && acceptorsList.length > 0) {
          bandStatus = (
            <div className="doc-declined-status-band remove-from-export">
              <span className="doc-statusband-check-wrapper">
                <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
              </span>
              <div>Document has been rejected by a receiver</div>
            </div>
          );
        } else if (signerList && signerList.length > 0) {
          bandStatus = (
            <div className="doc-declined-status-band remove-from-export">
              <span className="doc-statusband-check-wrapper">
                <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
              </span>

              <div>Document declined by a signer</div>
            </div>
          );
        }
      } else if (stage === "SENT_FOR_FILLING") {
        bandStatus = (
          <div className="doc-status-warning-band remove-from-export">
            <span className="doc-statusband-check-wrapper">
              <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
            </span>
            {/* check */}
            {docRecipientList &&
            docRecipientList.some(
              item =>
                item.user &&
                item.user.id === CURRENT_USER.id &&
                item.recipient_type === "FILLER",
            ) ? (
              <div>You need to fill this document before eSigning.</div>
            ) : (
              <div>Document sent for filling</div>
            )}
          </div>
        );
      }
    }
    return bandStatus;
  }
}

export default DocumentStatusBand;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/StatusBands/DocumentStatusBand.js